import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/chevron_left.svg'
import _imports_1 from '@/img/logo_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-36627102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal p-3 text-center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { class: "text-green fs-5" }
const _hoisted_12 = { class: "mt-2 fs-5" }
const _hoisted_13 = { class: "list mt-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, _hoisted_5)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$store.state.prenotazioneData.centro.personalData.completeName), 1)
      ]),
      (_ctx.$store.state.prenotazioneData.centro.contactData.shippingAddress.typedAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "L'appuntamento si svolgerà tramite videochiamata",
              text: "L'appuntamento si svolgerà tramite videochiamata"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$store.state.prenotazioneData.centro.contactData.shippingAddress.typedAddress), 1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.$filters.date(_ctx.$store.state.prenotazioneData.data, 'dddd DD MMMM YYYY')), 1),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_localized_text, {
            localizedKey: "Il trattamento avrà una durata indicativa di 60 minuti",
            text: "Il trattamento avrà una durata indicativa di 60 minuti"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fasce, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["listItem", { selected: _ctx.selectedFascia == item }]),
            key: i,
            onClick: ($event: any) => (_ctx.selectedFascia = item)
          }, _toDisplayString(_ctx.$filters.timespan(item.from)) + " - " + _toDisplayString(_ctx.$filters.timespan(item.to)), 11, _hoisted_14))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
          disabled: !_ctx.selectedFascia
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Seleziona",
            text: "Seleziona"
          })
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}